import React from "react";
import { useSelector } from "react-redux";

// material-ui
import makeStyles from "@material-ui/styles/makeStyles";
import Paper from "@material-ui/core/Paper";

// jazasoft
import { PageHeader, SimpleForm, TextInput, AutoCompleteArrayInput, SelectArrayInput, showNotification, required, translate } from "jazasoft";

// helper
import { inputOptions, isEmpty } from "../../utils/helpers";
import { Role } from "../../utils/types";
import getValidation from "../../utils/getValidation";
import { UsersFields } from "../../utils/entityFields";
import { useSetting } from "../../hooks";
import SettingKeys from "../../utils/SettingKeys";

//local
import useUser from "./useUser";

const useStyles = makeStyles(theme => ({
  container: {
    margin: theme.spacing(3),
    padding: theme.spacing(3)
  }
}));

const UserCreate = props => {
  const classes = useStyles();
  const { translate } = props;

  const fields = useSetting(SettingKeys.ENTITY_FIELDS, "users");
  const validationRule = useSetting(SettingKeys.ENTITY_FIELD_VALIDATION, "users");

  const { roles, choicesCustomer, choicesWarehouse, unitList, dispatch, onSave } = useUser(props);

  const formRoleIds = useSelector(state => state.form && state.form["record-form"]?.values?.roleIds);

  const roleMerchant = !isEmpty(roles) ? roles.find(r => r.roleId === Role.MERCHANT) : {};
  const roleWarehouse = !isEmpty(roles) ? roles.find(r => r.roleId === Role.WAREHOUSE) : {};
  const roleAdmin = !isEmpty(roles) ? roles.find(r => r?.roleId === Role.ADMIN_USER) : {};
  const fabricStroeManagment = !isEmpty(roles) ? roles.find(r => r.roleId === Role.FABRIC_STORE_MANAGEMENT) : {};
  const fabricQualityManagment = !isEmpty(roles) ? roles.find(r => r.roleId === Role.FABRIC_QUALITY_MANAGEMENT) : {};

  const onSubmit = values => {
    if (isEmpty(values.roleIds)) {
      dispatch(showNotification("resources.users.error.roles_required", { type: "danger" }));
      return;
    } else if (values.roleIds.includes(roleAdmin?.id) && values.roleIds.length > 1) {
      dispatch(showNotification("resources.users.error.not_valid_selection", { type: "danger" }));
      return;
    } else if (values.roleIds.includes(roleMerchant?.id) && isEmpty(values.customerIds)) {
      dispatch(showNotification(translate("resources.users.error.customer_required", { role: "Merchant" }), { type: "danger" }));
      return;
    } else if (values.roleIds.includes(roleWarehouse?.id) && isEmpty(values.warehouseIds)) {
      dispatch(showNotification(translate("resources.users.error.warehouse_required", { role: "Warehouse" }), { type: "danger" }));
      return;
    }
    onSave(values);
  };

  return (
    <div>
      <PageHeader title={translate("resources.users.page.create")} />

      <Paper className={classes.container}>
        <SimpleForm record={{ unitIds: unitList?.map(e => e.id) || [] }} onSubmit={onSubmit}>
          {unitList?.length > 1 && <SelectArrayInput validate={[required()]} source="unitIds" choices={unitList} {...inputOptions(3)} />}
          {fields.includes(UsersFields.FULL_NAME) && (
            <TextInput source="fullName" validate={getValidation(validationRule[UsersFields.FULL_NAME])} {...inputOptions(3)} />
          )}
          {fields.includes(UsersFields.USER_NAME) && (
            <TextInput source="username" validate={getValidation(validationRule[UsersFields.USER_NAME])} {...inputOptions(3)} />
          )}
          {fields.includes(UsersFields.EMAIL) && (
            <TextInput source="email" validate={getValidation(validationRule[UsersFields.EMAIL])} {...inputOptions(3)} />
          )}
          {fields.includes(UsersFields.MOBILE) && (
            <TextInput source="mobile" validate={getValidation(validationRule[UsersFields.MOBILE])} {...inputOptions(3)} />
          )}
          {fields.includes(UsersFields.ROLES) && (
            <SelectArrayInput validate={getValidation(validationRule[UsersFields.ROLES])} source="roleIds" choices={roles} {...inputOptions(3)} />
          )}
          {!isEmpty(roleMerchant) && formRoleIds?.includes(roleMerchant.id) && fields.includes(UsersFields.CUSTOMER) && (
            <AutoCompleteArrayInput
              label="Customers"
              allowEmpty={true}
              source="customerIds"
              choices={choicesCustomer}
              validate={getValidation(validationRule[UsersFields.CUSTOMER])}
              {...inputOptions(6)}
            />
          )}
          {!isEmpty(choicesWarehouse) && (formRoleIds?.includes(roleWarehouse?.id) || formRoleIds?.includes(fabricQualityManagment?.id) || formRoleIds?.includes(fabricStroeManagment?.id)) && fields.includes(UsersFields.WAREHOUSES) && (
            <SelectArrayInput
              label="Warehouses"
              allowEmpty={true}
              source="warehouseIds"
              choices={choicesWarehouse}
              validate={required()}
              {...inputOptions(6)}
            />
          )}
        </SimpleForm>
      </Paper>
    </div>
  );
};

export default translate(UserCreate);
